/* eslint-disable jsx-a11y/control-has-associated-label, jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from "react"
import * as Icon from "react-feather"
import EventFilterItemOption from "../event-filter-item-option"

class EventFilterItem extends Component {
  state = {
    optionSelected: false,
  }

  selectOption = () => {
    const { optionSelected } = this.state

    this.setState({
      optionSelected: !optionSelected,
    })
  }

  render() {
    const {
      optionList,
      title,
      selectedLabel,
      onSelect,
      selectedLength,
      defaultSelectedArr,
      filterWide,
      toggle,
      displayed,
    } = this.props

    return (
      <div
        className={`event-filter__item${filterWide ? "__wide" : ""}
        ${toggle ? "event-filter__item--open" : ""}`}
      >
        {toggle && (
          <div
            className="event-filter__item-close"
            onClick={displayed}
            onKeyDown={displayed}
            role="button"
            tabIndex={0}
          ></div>
        )}

        <div className="event-filter__item-inner">
          <div
            className="event-filter__item-header"
            onClick={displayed}
            onKeyUp={displayed}
            role="button"
            tabIndex={-1}
          >
            <Icon.ArrowLeft className="event-filter__item-back icon icon--sm" />
            <div className="event-filter__item-left">
              <p className="event-filter__item-title">{title}</p>
              {!toggle && selectedLabel && (
                <p className="event-filter__item-selection">{selectedLabel}</p>
              )}
            </div>
            <div className="event-filter__item-right">
              {selectedLabel && (
                <p className="event-filter__item-selected-count">
                  {selectedLength} selected
                </p>
              )}
              {toggle ? (
                <Icon.ChevronUp className="event-filter__item-icon icon icon--sm" />
              ) : (
                <Icon.ChevronDown className="event-filter__item-icon icon icon--sm" />
              )}
            </div>
            {selectedLabel && (
              <p
                className="event-filter__item-clear event-filter__item-clear--mobile"
                onClick={onSelect}
              >
                Clear
              </p>
            )}
          </div>

          {toggle && (
            <div className="event-filter__item-options">
              {selectedLabel && (
                <div className="event-filter__item-options-header">
                  <p className="event-filter__item-selection">
                    {selectedLabel}
                  </p>
                  <p className="event-filter__item-clear" onClick={onSelect}>
                    Clear
                  </p>
                </div>
              )}
              <form className="event-filter__item-options-list">
                <fieldset>
                  {optionList && Array.isArray(optionList)
                    ? optionList.map((option, index) => (
                        <EventFilterItemOption
                          title={option.name || option}
                          key={index}
                          optionSelect={this.selectOption}
                          value={option.value || option}
                          onSelect={onSelect}
                          defaultSelected={
                            defaultSelectedArr.includes(
                              option.value || option
                            ) || defaultSelectedArr.includes(option.name)
                          }
                          clear={selectedLength === 0}
                        />
                      ))
                    : Object.keys(optionList).map((key, index) => (
                        <EventFilterItemOption
                          title={optionList[key]}
                          key={index}
                          optionSelect={this.selectOption}
                          value={key}
                          onSelect={onSelect}
                          defaultSelected={defaultSelectedArr.includes(key)}
                          clear={selectedLength === 0}
                        />
                      ))}
                </fieldset>
              </form>
            </div>
          )}
        </div>
      </div>
    )
  }
}

EventFilterItem.defaultProps = {
  title: "",
}

export default EventFilterItem
